import axios from "axios";
import qs from "qs";

// api + "/finproinfo/" + id +"/findall"

import { api } from "@/plugins/util";

/**
 * 替换换行符以及其他
 */
export function trimNR(str) {
    return str.replace(/\r\n/g, '<br/>').replace(/\n/g, '<br/>').replace(/\s/g, '&nbsp;');
}

/**
 * 保存和提交产品
 *
 */
export function saveProduct({
    proname,
    type,
    guarantee,
    approval_model,
    policy,
    product_type,
    loanMin,
    loanMax,
    state,
    loanDeadlineMin,
    loanDeadlineMax,
    rateMin,
    rateMax,
    region,
    repayment_mode,
    introduction,
    access_conditions,
    product_feature,
    apply_group,
    cost,
    specialArea,
    regionId,
                                approvalMin,
                                approvalMax,
                                materials
}) {
    return axios.post(
        api + "/finproinfo/add",
        qs.stringify({
            proname,
            type,
            guarantee,
            approval_model,
            policy,
            product_type,
            loanMin,
            loanMax,
            state,
            loanDeadlineMin,
            loanDeadlineMax,
            rateMin,
            rateMax,
            region,
            repayment_mode,
            introduction,
            access_conditions,
            product_feature,
            apply_group,
            cost,
            specialArea,
            regionId,approvalMin,
            approvalMax,
            materials
        })
    );
}
/**
 * 产品列表显示
 *
 */
export function ListAjax(pageNum,proName) {
    return axios.get(api + "/finproinfo/findall", {
        params: {
            pageNum,
            proName
        }
    });
}
/**
 * 修改产品
 *
 */

export function updatePro({
    state,
    proname,
    type,
    guarantee,
    approval_model,
    policy,
    product_type,
    loanMin,
    loanMax,
    loanDeadlineMin,
    loanDeadlineMax,
    rateMin,
    rateMax,
    region,
    repayment_mode,
    introduction,
    access_conditions,
    product_feature,
    apply_group,
    cost,
    specialArea,
    regionId,
    id,approvalMin,
    approvalMax,
    materials
}) {
    return axios.post(
        api + "/finproinfo/update",
        qs.stringify({
            state,
            proname,
            type,
            guarantee,
            approval_model,
            policy,
            product_type,
            loanMin,
            loanMax,
            loanDeadlineMin,
            loanDeadlineMax,
            rateMin,
            rateMax,
            region,
            repayment_mode,
            introduction,
            access_conditions,
            product_feature,
            apply_group,
            cost,
            specialArea,
            regionId,
            id,approvalMin,
            approvalMax,
            materials
        })
    );
}

/**
 * 删除产品
 *
 */
export function deletePro(id) {
    return axios.post(
        api + "/finproinfo/delete",
        qs.stringify({
            id
        })
    );
}

/**
 * 政府页面的删除产品
 * @param id
 * @returns {AxiosPromise<any>}
 */
export function deleteReviewed(id) {
    return axios.post(
        api + "/finproinfo/deleteReviewed",
        qs.stringify({
            id
        })
    );
}

/**
 * 审核记录
 *
 */
export function checkPro(id, pageNum) {
    return axios.get(api + "/shpro/findallById", {
        params: {
            id,
            pageNum
        }
    });
}
/**
 * 运营产品列表显示
 *
 */
export function Listyy(pageNum, shstate,proName,serveBank) {
    return axios.get(api + "/finproinfo/findallBySh", {
        params: {
            pageNum,
            shstate,
            proName,
            serveBank
        }
    });
}
/**
 * 审核
 *
 */
export function check(proid, shidea, shstate, loginid, loginname) {
    return axios.post(
        api + "/shpro/add",
        qs.stringify({
            proid,
            shidea,
            shstate,
            loginid,
            loginname
        })
    );
}

// function padLeftZero(str) {
//     return ('00' + str).substr(str.length);
//
// }
export function MyListAjax(pageNum, status, pageSize) {
    return axios.post(api + "/finance/list", {
        params: {
            pageNum,
            status,
            pageSize
        }
    });
}
/**
 * 按部门展示信用数据
 *
 */
export function ListByDept(pageNum) {
    return axios.get(api + "/directory/findallByDept", {
        params: {
            pageNum
        }
    });
}
export function ListByZttype(pageNum) {
    return axios.get(api + "/directory/findallByZttype", {
        params: {
            pageNum
        }
    });
}
export function mySelect() {
    return axios.get(api + "/finproinfo/findallShIdea", {
        params: {}
    });
}

/**
 * 根据param获取字典数据
 * @param {Object} mark
 */
export function getTypes(mark){
    return axios.get(api + "/sysParam/select",{
        params:{
            mark
        }
    })
}

